/**
 * Pick the forecast events an apply produced, out of a version's recent trail.
 *
 * The forecast audit trail has no provenance marker for "the assistant wrote
 * this" — the write routes accept a uiContext but the forecast endpoints never
 * pass one — so the events belonging to one apply are identified by what the
 * card actually touched: this version, these accounts, since the moment apply
 * started.
 *
 * Pure and dependency-free so the selection rules can be tested directly; the
 * fetching and rendering live in ForecastChangeHistory.js.
 */

// A few seconds of clock skew between the browser and the server would
// otherwise hide every event this apply wrote.
export const CLOCK_SKEW_MS = 5000;

export function selectAppliedEvents({ events, since, accountIds = [] }) {
  const list = Array.isArray(events) ? events : [];
  const floor = since ? new Date(since).getTime() - CLOCK_SKEW_MS : 0;
  const wanted = new Set((accountIds || []).map(Number).filter(Number.isFinite));
  return list
    .filter(e => e && !e.isDeleted)
    .filter(e => {
      const at = new Date(e.createdAt).getTime();
      // An unparseable timestamp is kept: dropping a real change because its
      // date was odd would be the worse failure of the two.
      return Number.isNaN(at) ? true : at >= floor;
    })
    // Department-level events carry no accountId (a driver set across a whole
    // department). Those belong to the apply as much as the per-account rows.
    .filter(e => wanted.size === 0 || e.accountId == null || wanted.has(Number(e.accountId)))
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
}
